import React, { memo, useEffect, useState } from 'react';

import { View, Pressable } from 'react-native';
import { connect } from 'react-redux';

import { Navigation } from './screens/components';
import { COLOR, NAVBAR_BUTTON_DIM } from './constants/styles';
import { getRoutes } from './screens/routes';
import SideNav from './screens/nav_menus/sidebar_container';
import TopNav from './screens/TopNav';
import SyncOverlay from './screens/sync_overlay';
import { getCurrentEmployer, getAssociatedEmployer } from './selectors/employers';
import { EMPLOYER_TYPE_AIRFORCE, EMPLOYER_TYPE_MED_RECRUITER } from './constants/employerTypes';
export const NAV_HEIGHT = NAVBAR_BUTTON_DIM;

const MainTab = memo(function (props) {
  const routes = getRoutes(props.employerMode);
  const Comp = routes[props.screen];
  if (!Comp) {
    console.error('No component found for screen', props.screen);
    return null;
  }
  return (
    <View
      style={{
        flex: 1,
        display: props.activeTab === props.screen ? 'flex' : 'none',
      }}
    >
      <Comp {...props} />
    </View>
  );
});

const AuthedAppContainer = function (props) {
  useEffect(() => {
    if (props.internalBaseConfigError?.response?.httpStatusCode === 403) {
      Navigation.openScreen({ screen: 'Error' });
    }
  }, [props.internalBaseConfigError]);

  const [topNavOpen, setTopNavOpen] = useState(false);

  function handleTopNavMenuOpen(topNavOpen) {
    setTopNavOpen(topNavOpen);
  }
  function handleOverlayPress() {
    setTopNavOpen(false);
  }

  const internal = props.pathName?.toLowerCase().startsWith('/internal');

  const isMedRecruiterStaff = props.employer?.uiConfig?.type === EMPLOYER_TYPE_MED_RECRUITER;
  const isMedRecruiterPatient =
    !isMedRecruiterStaff &&
    props.associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_MED_RECRUITER;
  // const isMedRecruiterPatient = true;

  return (
    <View style={{ flex: 1, flexDirection: 'row', overflow: 'hidden' }}>
      {!internal && !isMedRecruiterPatient && (
        <View style={{ width: 320 }}>
          <SideNav currentTab={props.activeTab} internal={internal} />
        </View>
      )}
      <View style={{ flex: 1 }}>
        <TopNav
          sideNavOpen={true}
          currentTab={props.activeTab}
          onOpenMenu={handleTopNavMenuOpen}
          menuOpen={topNavOpen}
          internal={internal}
        />
        <View style={{ flex: 1 }}>
          {!!internal && <MainTab {...props} activeTab="Internal" screen="Internal" />}
          {!internal && <MainTab {...props} screen={props.activeTab} />}
        </View>
        <Pressable
          style={{
            position: 'absolute',
            top: NAV_HEIGHT,
            left: 0,
            bottom: 0,
            right: 0,
            pointerEvents: topNavOpen ? 'auto' : 'none',
          }}
          onPress={handleOverlayPress}
        >
          <View
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              backgroundColor: COLOR.overlayLight,
              transition: 'opacity 250ms ease-out',
              opacity: topNavOpen ? 1 : 0,
            }}
          />
        </Pressable>
      </View>
      {!props.fullSync && (
        <View style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0 }}>
          <SyncOverlay />
        </View>
      )}
    </View>
  );
};

function mapStateToProps(state, ownProps) {
  const associatedEmployer = getAssociatedEmployer(state);
  let activeTab = ownProps.pathName?.substring(1) || 'Home';

  return {
    fullSync: state.user.fullSync,
    activeTab,
    employer: getCurrentEmployer(state),
    employerMode: !!getCurrentEmployer(state),
    associatedEmployer,
    isMedRecruiter: associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_MED_RECRUITER,
    internalBaseConfigError: state.screens.baseConfig.error,
  };
}

export default memo(connect(mapStateToProps, null)(AuthedAppContainer));
